import { useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { ARTICLES_FOR_CCA_STEP2_QUERY, CcaStep2Article } from './articlesForStep2.query';
import { ArticlesForCcaStep2Query, ArticlesForCcaStep2QueryVariables } from './__generated__/ArticlesForCcaStep2Query';

export const useArticlesForCcaStep2 = (articleIds: string[], skip = false) => {
  const result = useQuery<ArticlesForCcaStep2Query, ArticlesForCcaStep2QueryVariables>(ARTICLES_FOR_CCA_STEP2_QUERY, {
    client: kmsClient,
    variables: { filter: { articleIds }, limit: articleIds.length },
    skip: skip || articleIds.length === 0,
    fetchPolicy: 'cache-and-network'
  });

  // `allArticles` returns a connection; flatten edges into a plain article list.
  // Memoized on `data` so the reference stays stable across renders.
  const articles = useMemo<CcaStep2Article[]>(
    () =>
      (result.data?.allArticles.edges ?? [])
        .map((edge) => edge?.node)
        .filter((node): node is CcaStep2Article => node !== null && node !== undefined),
    [result.data]
  );

  return { ...result, articles };
};
